import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Credit } from '../../models/credit';

@Component({
  selector: 'app-commande-header',
  templateUrl: './commande-header.component.html',
  styleUrls: ['./commande-header.component.scss'],
})
export class CommandeHeaderComponent implements OnChanges {
  @Input() currentEtape!: Credit.EtapeCommande;

  widthProgresBar = 0;
  progressMap: { [key in Credit.EtapeCommande]: number } = {
    [Credit.EtapeCommande.MA_COMMANDE]: 33.33,
    [Credit.EtapeCommande.MES_INFORMATIONS_ADMINISTRATIVES]: 66.66,
    [Credit.EtapeCommande.MA_VALIDATION]: 100,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentEtape'] && changes['currentEtape'].currentValue) {
      const newEtape = changes['currentEtape']
        .currentValue as Credit.EtapeCommande;
      this.widthProgresBar = this.progressMap[newEtape];
    }
  }
}
